import { Component, Input } from '@angular/core';
import { AuthService, CookieDisclaimerService } from '@signature-it/ngx-generic/services';
import {Router} from '@angular/router';

enum ButtonType {
    AllowAll = 'allow-all',
    DismissAll = 'dismiss-all',
    AllowSelected = 'allow-selected'
}

@Component({
    selector: 'cookie-disclaimer-btn',
    templateUrl: './cookie-disclaimer-btn.component.html',
    styleUrls: ['./cookie-disclaimer-btn.component.scss'],
    standalone: false
})
export class CookieDisclaimerBtnComponent {
    
    @Input() title = '';
    @Input() type: ButtonType
    @Input() classes;
    privacyPage: boolean = false;

    constructor(protected cookieDisclaimerSvc: CookieDisclaimerService,
                protected authService: AuthService,
                protected router: Router) {
        this.privacyPage = this.router.url.includes('privacy');
    }

    click() {
        if (this.type === ButtonType.AllowAll || this.type === ButtonType.DismissAll) {
            const val = this.type === ButtonType.AllowAll ? true : false;
            this.cookieDisclaimerSvc.statusTypeArray.forEach((status, key) => {
                if(status.type !== 'generic') {
                    status.value = val;
                }
            });
        }
        this.cookieDisclaimerSvc.setCookieDisclaimerCookie();
        this.cookieDisclaimerSvc.updateCookieDisclaimer(true);
        if(this.privacyPage) {
            this.authService.handleAuthentication('/');
        }
    }

}
